<template>
  <div class="bg-box">
    <div class="display_wrapper">
      <div class="title">选择你的平台</div>
      <div class="select-wrapper">
        <div class="platform" :class="{active: selectedPlatform==='ios'}" @click="selectedPlatform='ios'">
          <img  class="platform-icon" src='../../../../assets/wutong/ios.png' alt="logo" />
          <div class="platform-name" :class="{active: selectedPlatform==='ios'}">ios 下载</div>
        </div>
        <div class="platform" :class="{active: selectedPlatform==='android'}" @click="selectedPlatform='android'">
          <img  class="platform-icon" src='../../../../assets/wutong/android.png' alt="logo" />
          <div class="platform-name" :class="{active: selectedPlatform==='android'}">Android 下载</div>
        </div>
      </div>
      <!-- <div class="subtitle">
        安装后: 选择【出国留学】发起缴费, <br />
        单笔实付≥15,000 NZD, 入账后联系客服领取50 NZD
      </div> -->
      <div @click="Download" class="btn">
        立即下载App
      </div>
      <!-- <div class="subtitle">若未自动跳转，请点击按钮</div> -->
    </div>
  </div>
</template>

<script>
const iosLink = 'https://apps.apple.com/cn/app/%E6%A2%A7%E6%A1%90%E6%B1%87/id6742526842'
const androidLink = 'https://admin.wutong.co.nz/download.html'
export default {
  name: 'AppRegister',
  data() {
    return {
      iosLink,
      androidLink,
      selectedPlatform: 'android'
    }
  },
  mounted() {
    this.detectedPlatform();
  },
  methods: {
    detectedPlatform() {
      const ua = navigator.userAgent.toLowerCase()
      if (/android/i.test(ua)) {
        this.selectedPlatform = 'android'
      } else if (/iphone|ipad|ipod/i.test(ua)) {
        this.selectedPlatform = 'ios'
      }
    },
    Download() {
      if (this.selectedPlatform === 'ios') {
        window.location.href = this.iosLink;
      } else {
        window.location.href = this.androidLink;
        // Handle Android download
      }
    }
  }
}
</script>

<style scoped>
.select-wrapper{
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
  gap: 12px;
  margin: 1rem 0;
  .platform{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: 100%;
    border: 1px solid #B7BCC4;
    border-radius: 11px;
    padding: 1.5rem 0;
    cursor: pointer;
    transition: all 0.3s;
    &.active{
      /* background: #F0F4FF; */
      border-color: #3678FF;
    }
    .platform-name{
      margin-top: 0.5rem;
      font-size: 16px;
      color: #999999;
      font-weight: 500;
      transition: all 0.3s;
      &.active{
        color: #3678FF;
      }
    }
    .platform-icon{
      width: 44px;
      height: auto;
    }
  }
}
.bg-box {
  background-image: url('../../../../assets/wutong/newbg.jpg');
  background-size: 100% 100%;
  background-position: top center;
  background-repeat: no-repeat;
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* justify-content: center; */
}
.display_wrapper{
  margin-top: 28vh;
  background-color: #fff;
  border-radius: 14px;
  width: 90%;
  padding: 1rem 1.5rem;
  margin-bottom: 1rem;
  color: #222;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title{
    font-size: 17px;
    font-weight: 500;
  }
  .subtitle{
    font-size: 12px;
    color: #666;
    /* margin-top: 0.5rem; */
  }
  .icon{
    width: 138px;
    height: auto;
    margin: 20px 0;
  }
  .btn{
    margin-top: 2rem;
    width: 100%;
    max-width: 400px;
    background: #3678FF;
    border-radius: 11px;
    color: #fff;
    font-size: 17px;
    text-align: center;
    padding: 0.8rem 0;
    cursor: pointer;
    user-select: none;
    color: #fff;
    margin-bottom: 13px;
  }
}
</style>
